module.exports = __webpack_public_path__ + "static/1-c2526da3cb9a790bc563acd363973bff.jpg";